// https://github.com/visma-meglerfront/sweet-modal-vue/issues/60
import SweetModal from 'sweet-modal-vue/src/components/SweetModal.vue'
import SweetModalTab from 'sweet-modal-vue/src/components/SweetModalTab.vue'
import Vue from 'vue'

Vue.component('SweetModal', SweetModal)
Vue.component('SweetModalTab', SweetModalTab)
